<div class="event-card-container">
  <div class="card-header">Convite Cortesia</div>
  <div class="card-content" [class.no-actions]="invitation.status === invitationStatusEnum.PENDING">
    <div class="event-info-area">
      <div class="event-title-area">
        <p>{{ invitation.event.title }}</p>
      </div>
      <div class="event-banner-area">
        <img [src]="loadEventImage(invitation.event.thumbnail)" alt="Banner do evento" />
      </div>
      <div class="event-details-area">
        <p>
          {{ invitation.event.start_date | date: "shortDate" }} - {{ invitation.event.start_date | date: "shortTime" }}
        </p>
        <p>{{ invitation.event.address.location_name }}</p>
        <p>{{ invitation.event.address.street }} - {{ invitation.event.address.number }}</p>
        <p>{{ invitation.event.address.city_name }} - {{ invitation.event.address.state }}</p>
      </div>
    </div>
    @if (invitation.status === invitationStatusEnum.PENDING) {
      <div class="actions-area">
        <app-button (btnClick)="handleAcceptClick()" styleType="primary" [disabled]="isLoading">ACEITAR</app-button>
        <app-button (btnClick)="handleDeclineClick()" styleType="secondary" [disabled]="isLoading">RECUSAR</app-button>
      </div>
    } @else if (invitation.status === invitationStatusEnum.ACCEPTED) {
      <div class="actions-area">
        <app-button [routerLink]="['/my-orders']" styleType="primary" class="col-span">
          VISUALIZAR INGRESSOS
        </app-button>
      </div>
    }
    <div class="invite-info-area">
      @if (invitation.ticket) {
        <div class="invite-info-field">
          <p><b>Ingresso: </b>{{ invitation.ticket.title }} — {{ invitation.ticket.batch_label }}</p>
          <p>Recebido por convite · Cortesia gratuita</p>
          @if (invitation.expires_at && invitation.status === invitationStatusEnum.PENDING) {
            <p><b>Aceite até: </b>{{ invitation.expires_at | date: "dd/MM/yyyy HH:mm" }}</p>
          }
        </div>
      }
      <div class="username-area invite-info-field">
        <p><b>Nome: </b> {{ invitation.user_name }} {{ invitation.user_last_name }}</p>
      </div>
      <div class="quantity-area invite-info-field">
        <p><b>Qtd. Ingressos: </b> {{ invitation.quantity }}</p>
      </div>
      <div class="is-transferable-area invite-info-field">
        <p><b>Transferível: </b> {{ invitation.transferable ? "Sim" : "Não" }}</p>
      </div>

      <div class="cpf-area invite-info-field">
        <p><b>CPF: </b> {{ invitation.user_cpf }}</p>
      </div>
      <div class="status-area invite-info-field">
        <p>
          <b>Status: </b>
          <span class=" status status--{{ invitation.status.toLowerCase() }}">{{
            invitation.status | invitationStatusEnum
          }}</span>
        </p>
      </div>
      <div class="description-area invite-info-field">
        <p>
          <b>Descrição: </b>
          {{ invitation.description }}
        </p>
      </div>
    </div>
  </div>
</div>
